module.exports = __webpack_public_path__ + "static/media/TN-Women-Outer.2d97c2f5.svg";